import React, { ReactNode } from 'react';
import EmptyState from '@components/common/EmptyState';
import { LoadingState, LoadingOverlay } from '@components/common/loading';

interface TableStateWrapperProps {
  isLoading: boolean;
  isFetching?: boolean;
  isEmpty: boolean;
  emptyTitle?: string;
  emptyDescription?: string;
  emptyType?: 'search' | 'default' | 'contracts' | 'meetings';
  loadingMessage?: string;
  children: ReactNode;
  customEmptyState?: ReactNode;
}

export const TableStateWrapper: React.FC<TableStateWrapperProps> = ({
  isLoading,
  isFetching = false,
  isEmpty,
  emptyTitle,
  emptyDescription,
  emptyType = 'default',
  loadingMessage = 'Loading...',
  children,
  customEmptyState
}) => {
  // Initial loading - show full loading state
  if (isLoading) {
    return <LoadingState message={loadingMessage} />;
  }

  // Empty state - show custom or default
  if (isEmpty) {
    if (customEmptyState) {
      return <>{customEmptyState}</>;
    }
    // Fallback to default EmptyState if no custom state provided
    if (emptyTitle) {
      return <EmptyState type={emptyType} title={emptyTitle} description={emptyDescription || ''} />;
    }
    // If neither custom nor default is provided, show generic empty message
    return <EmptyState type="default" title="No data available" />;
  }

  // Show content with optional fetching overlay
  return (
    <>
      {isFetching && !isLoading && <LoadingOverlay variant="page" />}
      {children}
    </>
  );
};

export default TableStateWrapper;
